"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _customPage = require("@/api/customPage");
var _router = _interopRequireDefault(require("@/router"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  props: [],
  data: function data() {
    return {
      id: '',
      dialogVisible1: false,
      ruleForm: {
        sourceCode: ''
      },
      options: [],
      rules: {
        sourceCode: [{
          required: true,
          message: '请选择商品来源',
          trigger: 'change'
        }]
      }
    };
  },
  methods: {
    openGoodsList: function openGoodsList() {
      _router.default.push({
        path: '/activityManagement/goodsListActive'
      });
    },
    open: function open(data) {
      var _this = this;
      console.log(data);
      this.id = data.id;
      this.getOptions();
      (0, _customPage.moduleDetail)({
        moduleId: this.id
      }).then(function (res) {
        if (res.data && res.data.goodsActivity != null) {
          _this.ruleForm.sourceCode = res.data.goodsActivity.activityId;
        }
      });
      this.dialogVisible1 = true;
    },
    getOptions: function getOptions() {
      var _this2 = this;
      (0, _customPage.fullList)().then(function (res) {
        _this2.options = res.data;
      });
    },
    onClose: function onClose() {
      this.$refs['ruleForm'].resetFields();
      this.dialogVisible1 = false;
    },
    submitForm: function submitForm(formName) {
      var _this3 = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          var code = '';
          var openUrl = '';
          _this3.options.map(function (i) {
            if (i.id === _this3.ruleForm.sourceCode) {
              code = i.platformCode;
              openUrl = i.openUrl;
            }
          });
          (0, _customPage.saveOrUpdateBanner)({
            moduleId: _this3.id,
            goodsActivity: {
              activityId: _this3.ruleForm.sourceCode,
              activityType: 6,
              unionCode: code,
              openUrl: openUrl
            }
          }).then(function (res) {
            if (res.data) {
              _this3.$notify.success({
                title: '温馨提示',
                message: '操作成功'
              });
              _this3.onClose();
              _this3.$emit('refresh', _this3.id);
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  }
};